import { MaskitoOptions, maskitoTransform } from '@maskito/core'
import { useMaskito } from '@maskito/react'
import { ComponentProps } from 'react'
import { Controller } from 'react-hook-form'
import { IonInput } from '../styled'

type MaskInputProps = {
  name: string
  maskitoOptions: MaskitoOptions
} & Omit<ComponentProps<typeof IonInput>, '$invalid'>

export function MaskInput({
  label,
  name,
  type,
  children,
  maskitoOptions,
  ...inputProps
}: MaskInputProps) {
  const maskito = useMaskito({ options: maskitoOptions })

  return (
    <Controller
      name={name}
      defaultValue=''
      render={({
        field: { onChange, value },
        fieldState: { error, invalid },
      }) => {
        return (
          <IonInput
            className={invalid ? 'ion-invalid ion-touched' : ''}
            ref={async (elInput) => {
              if (elInput) {
                const input = await elInput.getInputElement()
                maskito(input)
              }
            }}
            onIonInput={(e) => {
              onChange(e.detail.value || '')
            }}
            value={maskitoTransform(value, maskitoOptions)}
            name={name}
            label={label}
            type={type}
            errorText={error?.message || 'Обязательное поле'}
            {...inputProps}
            labelPlacement='floating'
            fill='outline'
            mode='md'
          >
            {children}
          </IonInput>
        )
      }}
    />
  )
}
